export enum ChangeIdentificationAddress {
  CORRECTADDRESS = 'correct_address',
  INCORRECTADDRESS = 'incorrect_address',
}

export default ChangeIdentificationAddress;
